import { render, staticRenderFns } from "./CentralKitchen.vue?vue&type=template&id=c3ddfe38&"
import script from "./CentralKitchen.vue?vue&type=script&lang=js&"
export * from "./CentralKitchen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports